import { type EoReader, PacketAction, PacketFamily } from 'eolib';
import type { Client } from '@/client';
import { FAMILY_FORGE } from '@/forge-protocol';

export function registerForgeHandlers(client: Client): void {
  client.bus!.registerPacketHandler(FAMILY_FORGE as PacketFamily, PacketAction.List,
    (reader: EoReader) => client.forgeController.handleOwnedSync(reader));
  client.bus!.registerPacketHandler(
    FAMILY_FORGE as PacketFamily,
    PacketAction.Open,
    (reader: EoReader) => client.forgeController.handleOpened(reader),
  );

  client.bus!.registerPacketHandler(
    FAMILY_FORGE as PacketFamily,
    PacketAction.Reply,
    (reader: EoReader) => client.forgeController.handleReply(reader),
  );
}
